import { createAction } from "@reduxjs/toolkit";
import { Event } from "../segment/segmentEvents";

export const trackSegmentEvent = createAction<Event>("SEGMENT/TRACK_EVENT");
